// @flow

import React from 'react';
import styles from './select.scss';

import { getUniqueId } from '../../../../services/helpers';

const dropdownIcnUrl = require('../../../../assets/images/dropdown_icn.svg');

// Need to add a value field in select. So that inside each component we don't have to manually set during component mounting

type Props = {
  optionsArrOfObj: Array<any>,
  label: string,
  onSelect?: Function,
  nameValStrings?: Object,
  selectedOpt?: Object,
  enableSearch?: boolean,
  disabled?: boolean,
  disabledClass?: string,
  selectedWrapperClass?: string,
  disableNone?: boolean,
  showOptions?: boolean,
  displayAccessorFunction?: Function,
  onSearchValueChange?: Function,
  filterFunction?: Function,
  customDropDownImage?: string
};

type State = {
  selectedOpt: Object,
  showOptions: boolean,
  inputVal: string,
  optionsArrOriginal: Array<any>,
  optionsArrFiltered: Array<any>
};

class Select extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.selectRef = null;
    this.state = {
      selectedOpt: this.props.selectedOpt,
      showOptions: this.props.showOptions || false,
      inputVal: '',
      optionsArrOriginal: this.props.optionsArrOfObj,
      optionsArrFiltered: this.props.optionsArrOfObj
    };
    this.nameKey =
      (this.props.nameValStrings && this.props.nameValStrings.nameKey) || 'key';
    this.valKey =
      (this.props.nameValStrings && this.props.nameValStrings.valKey) || 'val';

    this.selectLabelId = `select-label-${getUniqueId(4)}`;
    this.inputFieldId = `input-field-${getUniqueId(4)}`;
    this.selectWrapperId = `select-wrapper-${getUniqueId(4)}`;
  }

  componentDidMount() {
    this.attachDocumentLevelEventHandler(); // hacky solution
    if (this.props.selectedOpt) {
      this.selectOption(this.props.selectedOpt);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.selectedOpt !== this.props.selectedOpt &&
      this.state.selectedOpt !== nextProps.selectedOpt
    ) {
      this.selectOption(nextProps.selectedOpt);
    }
    if (
      nextProps.showOptions &&
      nextProps.showOptions !== this.props.showOptions
    ) {
      this.setState({
        showOptions: nextProps.showOptions
      });
    }
    if (nextProps.optionsArrOfObj) {
      this.setState({
        optionsArrOriginal: nextProps.optionsArrOfObj,
        optionsArrFiltered: nextProps.optionsArrOfObj
      });
    }
  }

  shouldComponentUpdate(nextProps: Object, nextState: Object) {
    let propsUpdated = true;
    let stateUpdated = true;
    if (nextProps) {
      if (
        nextProps.optionsArrOfObj === this.props.optionsArrOfObj &&
        nextProps.label === this.props.label &&
        nextProps.nameValStrings === this.props.nameValStrings &&
        nextProps.selectedOpt === this.props.selectedOpt &&
        nextProps.enableSearch === this.props.enableSearch &&
        nextProps.disabled === this.props.disabled &&
        nextProps.disabledClass === this.props.disabledClass &&
        nextProps.selectedWrapperClass === this.props.selectedWrapperClass &&
        nextProps.disableNone === this.props.disableNone &&
        nextProps.showOptions === this.props.showOptions
      ) {
        propsUpdated = false;
      }
    }
    if (nextState) {
      if (
        nextState.selectedOpt === this.state.selectedOpt &&
        nextState.showOptions === this.state.showOptions &&
        nextState.inputVal === this.state.inputVal &&
        nextState.optionsArrOriginal === this.state.optionsArrOriginal &&
        nextState.optionsArrFiltered === this.state.optionsArrFiltered
      ) {
        stateUpdated = false;
      }
    }
    return propsUpdated || stateUpdated;
  }

  getMatcher(elem, selector) {
    // Polyfill for fucked up android devices. Only writing because of bad decision making
    const matches = document.querySelectorAll(selector);
    for (let id = 0; id < matches.length; id += 1) {
      if (matches[id] === elem) {
        return true;
      }
    }
    return false;
  }

  getClosest(elem, selector) {
    // Source - https://gomakethings.com/how-to-get-the-closest-parent-element-with-a-matching-selector-using-vanilla-javascript/
    for (; elem && elem !== document; elem = elem.parentNode) {
      if (
        typeof elem.matches === 'function'
          ? elem.matches(selector)
          : this.getMatcher(elem, selector)
      ) {
        return elem;
      }
    }
    return null;
  }

  handleChange(val: string) {
    this.setState(
      {
        inputVal: val
      },
      () =>
        this.props.onSearchValueChange
          ? this.props.onSearchValueChange(val)
          : this.filterOptionsArr() // update array of elements
    );
  }

  filterOptionsArr() {
    const searchStr = this.state.inputVal && this.state.inputVal.toLowerCase();

    const filteredArr = this.state.optionsArrOriginal.filter(
      this.props.filterFunction
        ? elem => this.props.filterFunction(elem, searchStr)
        : elem =>
            elem &&
            elem[this.nameKey] &&
            elem[this.nameKey].toLowerCase().indexOf(searchStr) >= 0
    );

    this.setState({
      optionsArrFiltered: filteredArr
    });
  }

  selectOption(obj: Object) {
    if (this.selectRef) {
      this.setState(
        {
          selectedOpt: obj,
          showOptions: false
        },
        () => {
          if (this.props.onSelect)
            this.props.onSelect(obj ? obj[this.nameKey] : '', obj);
        }
      );
    }
  }

  attachDocumentLevelEventHandler() {
    // flow-disable-next-line
    document.querySelector('body').addEventListener('mousedown', e => {
      const elem =
        typeof e.target.closest === 'function'
          ? e.target.closest(`#${this.selectWrapperId}`)
          : this.getClosest(e.target, `#${this.selectWrapperId}`); // Self made polyfill - regret

      const inputSearchElem =
        typeof e.target.closest === 'function'
          ? e.target.closest(`#${this.inputFieldId}`)
          : this.getClosest(e.target, `#${this.inputFieldId}`); // Self made polyfill - regret

      // eslint-disable-next-line
      if ((elem && !this.state.showOptions) || inputSearchElem) {
        // show options-wrapper
        this.setState({
          showOptions: true
        });
      } else if (!elem) {
        // hide options wrapper
        setTimeout(() => {
          this.setState({
            showOptions: false
          });
        }, 200);
      }
    });
  }

  displayOption(elem: Object) {
    if (!this.props.displayAccessorFunction) {
      return elem[this.nameKey];
    }
    return this.props.displayAccessorFunction(elem);
  }

  selectLabelId: string;
  nameKey: string;
  valKey: string;
  inputFieldId: string;
  // {elem[this.nameKey]}

  renderOptions() {
    return this.state.optionsArrFiltered.map((elem, i) => (
      <div
        className={`${styles.optionRow} l-row a-center`}
        onClick={() => this.selectOption(elem)}
        title={elem[this.nameKey]}
        key={i}
      >
        {this.displayOption(elem)}
      </div>
    ));
  }

  render() {
    const selectRef = el => {
      this.selectRef = el;
    };
    let customStyles = {};
    if (this.props.styles) {
      customStyles = this.props.styles;
    }
    return (
      <div
        id={this.selectWrapperId}
        ref={selectRef}
        style={customStyles}
        className={`${styles.selectWrapper} ${
          this.props.disabled ? styles[this.props.disabledClass] : ''
        } select-wrapper ${this.props.selectedWrapperClass}`}
      >
        <div
          id={this.selectLabelId}
          className={`${styles.labelWrapper} l-row a-center"`}
        >
          <div
            className={`${styles.selectLabel} l-row a-center select-label`}
            title={
              this.state.selectedOpt
                ? // ? this.state.selectedOpt[this.nameKey]
                  this.displayOption(this.state.selectedOpt)
                : this.props.label
            }
          >
            {this.state.selectedOpt
              ? // ? this.state.selectedOpt[this.nameKey]
                this.displayOption(this.state.selectedOpt)
              : this.props.label}
          </div>
          <div className={`${styles.selectArrowIcn} l-row a-center`}>
            <img
              src={
                this.props.customDropDownImage
                  ? this.props.customDropDownImage
                  : dropdownIcnUrl
              }
              alt=""
            />
          </div>
        </div>

        {this.state.showOptions ? (
          <div className={`${styles.optionsWrapper}`}>
            {this.props.enableSearch ? (
              <div
                className={`${styles.optionRow} ${styles.searchWrapper} l-row a-center`}
              >
                <input
                  id={this.inputFieldId}
                  className={`${styles.selectSearchInput}`}
                  placeholder="Search"
                  value={this.state.inputVal}
                  onChange={e => this.handleChange(e.target.value)}
                />
              </div>
            ) : null}

            {!this.props.disabled ? (
              <div className={`${styles.optionsRowParent} options-row-parent`}>
                {this.props.disableNone ? null : (
                  <div
                    className={`${styles.optionRow} l-row a-center`}
                    onClick={() => this.selectOption({})}
                  >
                    NONE
                  </div>
                )}
                {this.renderOptions()}
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    );
  }
}

export default Select;
